import { useEffect, useState } from 'react';

// Returns `value` delayed by `ms` ms after the last change. Each new value
// resets the timer (via the useEffect cleanup), so rapid updates collapse to
// a single trailing emission.
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), ms);
    return () => window.clearTimeout(id);
  }, [value, ms]);
  return debounced;
}
